import { render, staticRenderFns } from "./AuthorisedContactStep.vue?vue&type=template&id=2efe3c16&"
import script from "./AuthorisedContactStep.vue?vue&type=script&lang=ts&"
export * from "./AuthorisedContactStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports